<div class="flex items-center gap-1 text-sm">
  Legenda
  <button
    matIconButton
    type="button"
    [matMenuTriggerFor]="legendMenu"
    matTooltip="Legenda"
    [attr.aria-label]="'Legenda'"
  >
    <mat-icon>info_outline</mat-icon>
  </button>
  <mat-menu #legendMenu="matMenu">
    <div
      class="flex flex-col gap-1 shrink-0 py-2 px-3"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      tabindex="0"
      role="menuitem"
    >
      @for (item of items(); track item.label) {
        <div class="flex items-center gap-2">
          <span
            class="inline-block w-4 h-4 rounded-full shrink-0"
            [style]="item.swatchStyle"
          ></span>
          <span class="text-sm text-on-surface">{{ item.label }}</span>
        </div>
      }
    </div>
  </mat-menu>
</div>
